module.exports = __webpack_public_path__ + "media/images/core_values/compassion-fae721ae6050f2ddcf23bcc874bdca13.png";